/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Profile_Security_Agent_Passkey_Last_UsedInputs */



/**
* | output |
* | --- |
* | "Last used {date}" |
*
* @param {Profile_Security_Agent_Passkey_Last_UsedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_agent_passkey_last_used = /** @type {((inputs: Profile_Security_Agent_Passkey_Last_UsedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Agent_Passkey_Last_UsedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Zuletzt verwendet am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Last used ${i?.date}`)
});